import SelectBox from "devextreme-react/select-box";
import { useCommonContext } from "../../contexts/common";
import React, { useEffect, useMemo, useState } from "react";
import { loadKhoanNopGroupStart } from "../../state/actions/khoanNopGroupActions";
import { PageBaseStatus } from "../../models/pageBaseStatus";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../state/reducers";

import { sf_khoannop_group } from "../../models/response/category/sf_khoannop_group";

type ComboBoxDanhSachDichVuProps = {
    isReadonly?: boolean,
    value?: number,
    onValueChanged: (id: number) => void,
    className?: string,
    isShowClearButton?: boolean,
    preText?: string,
    stylingMode?: "outlined" | "filled" | "underlined"
}
const ComboBoxDanhSachDichVu = (props: ComboBoxDanhSachDichVuProps) => {
    const { dm_coso_id } = useSelector((x: RootState) => x.common)
    const { status, sf_khoannop_groups } = useSelector((x: RootState) => x.khoanNopGroup)
    const { translate } = useCommonContext();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadKhoanNopGroupStart());
    }, [])
    const dataSource = useMemo(() => {
        return sf_khoannop_groups.filter(x => x.dm_coso_id === dm_coso_id && (x.is_dichvu === true || x.is_dichvu_fixed == true));
    }, [sf_khoannop_groups, dm_coso_id])
    return (
        <SelectBox dataSource={dataSource}
            displayExpr={"ten_khoan_nop_group"}
            valueExpr={"id"}
            value={props.value}
            stylingMode={props.stylingMode || "outlined"}
            readOnly={props.isReadonly === true}
            placeholder={translate("Chọn dịch vụ")}
            width="100%"
            className={"default_selectbox " + (props.className ? props.className : "")}
            showClearButton={props.isShowClearButton === true}
            onValueChanged={(e) => {
                if (e.event) props.onValueChanged(e.value ?? 0)
            }} />
    );
}
export default ComboBoxDanhSachDichVu;